export const Job = {
	// Job related Api calls

	bookmarkJob(params) {
		return this.service.post(
			'/api/job/'+params.job_id+'/bookmark',
			params,
			response => Promise.resolve(response)
		)
	},

	askQuestion(params) {
		return this.service.post(
			'/api/job/'+params.job_id+'/ask-question',
			params,
			response => Promise.resolve(response)
		)
	},

	loadJobQuestions(params) {
		return this.service.post(
			'/api/job/'+params.job_id+'/questions',
			params,
			response => Promise.resolve(response)
		)
	},

	trackJobApply(params) {
		return this.service.post(
			'/api/job/'+params.job_id+'/track-apply-click',
			params,
			response => Promise.resolve(response)
		)
	},

	trackJobExpand(params) {
		return this.service.post(
			'/api/job/'+params.job_id+'/track-job-expand',
			params,
			response => Promise.resolve(response)
		)
	},

	reportExpiredJob(params) {
		return this.service.post(
			'/api/job/'+params.job_id+'/report-expired',
			params,
			response => Promise.resolve(response)
		)
	}
}
